import { Injectable, inject } from '@angular/core';
import { sortFilters, IFilterFieldSpec, stringOperatorsSpecs, IFilterSpec } from '@aston/foundation';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class ImportListFilterService {
	private translateService = inject(TranslateService);


	importColumnFieldFilterSpec: IFilterFieldSpec = {
		field: { label: 'Forms.CommonLabels.Column', value: 'Column' },
		operatorSpecs: stringOperatorsSpecs,
	};

	importErrorCodeFieldFilterSpec: IFilterFieldSpec = {
		field: { label: 'Forms.CommonLabels.ErrorCode', value: 'ErrorCode' },
		operatorSpecs: stringOperatorsSpecs,
	};

	importStatusFieldFilterSpec: IFilterFieldSpec = {
		field: { label: 'Forms.CommonLabels.Status', value: 'Status' },
		operatorSpecs: stringOperatorsSpecs,
	};

	spec$: Observable<IFilterSpec> = of(null).pipe(
		map(_ => ({
			items: [
				this.importColumnFieldFilterSpec,
				this.importErrorCodeFieldFilterSpec,
				this.importStatusFieldFilterSpec,
			]
				.sort(sortFilters(this.translateService))
		}))
	);
}
